import { render } from "./BrandGesundAt.vue?vue&type=template&id=a0244e26"
import script from "./BrandGesundAt.vue?vue&type=script&lang=ts"
export * from "./BrandGesundAt.vue?vue&type=script&lang=ts"

import "./BrandGesundAt.vue?vue&type=style&index=0&id=a0244e26&lang=scss"
script.render = render

export default script